<template>
  <basic-container>
    <el-tabs v-model="activeName" type="card" @tab-click="handleSwitch">
      <el-tab-pane name="intoPark">
        <span slot="label"><i class="el-icon-bottom-right"></i>入场记录</span>
      </el-tab-pane>
      <el-tab-pane name="outPark">
        <span slot="label"><i class="el-icon-top-right"></i>出场记录</span>
      </el-tab-pane>
      <el-tab-pane name="remainPark">
        <span slot="label"><i class="el-icon-s-flag"></i> 在场记录</span>
      </el-tab-pane>
    </el-tabs>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :search.sync="searchForm"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="refreshChange"
    >
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          v-if="showInImageBtn"
          plain
          @click="handleImageShow(scope.row)"
          >入场图片
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="showOutImageBtn"
          plain
          @click="handleInOutImageShow(scope.row)"
          >出入图片
        </el-button>
        <el-button
          type="text"
          size="small"
          plain
          v-if="scope.row.isInGroup == 1 && permissionList.parkingSpaceGroup"
          @click="openCarGroup(scope.row)"
        >查看车位组
        </el-button>
      </template>
      <template slot-scope="scope" slot="spaceIdSearch">
        <el-form-item prop="spaceId">
          <selectSearch  v-model="spaceId" :dicData="spacelist"></selectSearch>
          <!-- <el-select
            v-model="spaceId"
            filterable
            placeholder="请选择停车场"
            style="width: 100%"
            @change="userDistricts"
          >
            <el-option
              v-for="item in spacelist"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
      </template>
      <template slot-scope="scope" slot="dateRangeSearch">
        <el-form-item prop="dateRange">
          <div style="display: flex;">
            <el-date-picker
              style="width:42%;"
              v-model="query.startTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="开始日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.endTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="结束日期"
            >
            </el-date-picker>
          </div>
          <!-- <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="到"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker> -->
        </el-form-item>
      </template>
      <template slot-scope="scope" slot="payTypeSearch">
        <el-select
          v-model="payType"
          placeholder="支付方式"
          clearable="true"
          @change="onChangePayType"
        >
          <el-option
            v-for="item in payTypeList"
            :key="item.value"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="shouldAccountSearch">
        <el-input
          placeholder="应缴总额"
          v-model="shouldAccount"
          :disabled="true"
          style="color: red"
        >
        </el-input>
      </template>
      <template slot-scope="scope" slot="realityAccountSearch">
        <el-input placeholder="实缴总额" v-model="realityAccount" :disabled="true"> </el-input>
      </template>
      <!--  -->
      <template slot-scope="{ row }" slot="cloudCarImage_intoPark" v-if="activeName === 'intoPark'">
        <img
          style="height: 40px"
          :src="row.cloudCarImage"
          @mouseover="(e) => showImage(e, row.cloudCarImage)"
          @mouseout="hideImage"
        />
      </template>
      <template slot-scope="{ row }" slot="cloudCarInImage" v-if="activeName === 'outPark'">
        <img
          style="height: 40px"
          :src="row.cloudCarInImage"
          @mouseover="(e) => showImage(e, row.cloudCarInImage)"
          @mouseout="hideImage"
        />
      </template>
      <template slot-scope="{ row }" slot="cloudCarImage" v-if="activeName === 'outPark'">
        <img
          style="height: 40px"
          :src="row.cloudCarImage"
          @mouseover="(e) => showImage(e, row.cloudCarImage)"
          @mouseout="hideImage"
        />
      </template>
      <!--  -->
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-download" @click="openExportExcel">导 出</el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="按条件导出"
      append-to-body
      :visible.sync="exportExcelFlag"
      @closed="closeDialog"
    >
      <avue-form
        v-model="exportExcelForm"
        ref="exportExcelFormRef"
        :option="exportExcelOption"
        @submit="exportExcel"
      >
      </avue-form>
    </el-dialog>
    <el-dialog
      title="出入对比图片"
      append-to-body
      :visible.sync="showOutInPic"
      @closed="closeOutInPicDialog"
      style="width: 2100px; height: 800px"
    >
      <el-row>
        <el-col span="11" offset="1">
          <el-row>
            <el-col offset="10"><span class="demonstration">入场图片</span></el-col>
          </el-row>
          <el-row>
            <el-image
              :src="dialog.inImage"
              style="width: 440px; height: 260px"
              :fit="fit"
            ></el-image>
          </el-row>
        </el-col>
        <el-col span="11" offset="1">
          <el-row>
            <el-col offset="10"><span class="demonstration">出场图片</span></el-col>
          </el-row>
          <el-row>
            <el-image
              :src="dialog.outImage"
              style="width: 440px; height: 260px"
              :fit="fit"
            ></el-image>
          </el-row>
        </el-col>
      </el-row>
      <el-row> </el-row>
      <!-- <el-row>
        <el-col offset="2"><span class="demonstration">入场图片</span></el-col>
        <el-col offset="4"><span class="demonstration">出场图片</span></el-col>
      </el-row>
      <el-row>
        <el-image :src="dialog.inImage" style="width: 400px; height: 300px" :fit="fit"></el-image>
        <el-image :src="dialog.outImage" style="width: 400px; height: 300px" :fit="fit"></el-image>
      </el-row>-->
      <!--<div class="demo-image__placeholder">
        <div class="block">
          <span class="demonstration">默认</span>
          <el-image :src="dialog.inImage" style="width: 400px; height: 300px" :fit="fit"></el-image>
        </div>
        <div class="block">
          <span class="demonstration">自定义</span>
          <el-image :src="dialog.outImage" style="width: 400px; height: 300px" :fit="fit">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
        </div>
      </div>-->
    </el-dialog>
    <exportExcel ref="exportExcel"></exportExcel>
    <carGroup ref="carGroup"></carGroup>
  </basic-container>
</template>

<script>
import {
  getParkSpaceNode,
  getCarInList,
  getCarOutList,
  getRemainList,
  getMoneyStatistic,
} from '@/api/v4ward/car/carinoutinfo';
import { mapGetters } from 'vuex';
import intoParkOption from './carinout-option_intoPark';
import outParkOption from './carinout-option_outPark';
import remainParkOption from './carinout-option_remainPark';
import exportExcel from './exportExcel';
import { getDictionary } from '@/api/common';
import carGroup from "./car-group.vue";

export default {
  components: { exportExcel,carGroup },
  data() {
    return {
      activeName: 'intoPark',
      spacelist: [],
      exportExcelForm: {},
      showOutInPic: false,
      dialog: {
        inImage: '',
        outImage: '',
      },
      dateRange: [],
      payType: '',
      payTypeName: '',
      payTypeList: [],
      spaceId: '',
      shouldAccount: '',
      realityAccount: '',
      exportExcelFlag: false,
      showInImageBtn: true,
      showOutImageBtn: false,
      spaceParkTemp: '',
      form: {},
      query: {
        startTime:'',
        endTime:'',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      //导出条件弹框
      exportExcelOption: {
        align: 'center',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: '停车场',
            type: 'tree',
            prop: 'spaceId',
            search: true,
            width: 150,
            props: {
              label: 'title',
              value: 'key',
            },
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
            span: 12,
            rules: [
              {
                required: true,
                message: '请选择停车场',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车牌号',
            prop: 'carNo',
            span: 12,
          },
          {
            label: '入场时间',
            prop: 'inTime',
            span: 24,
            search: true,
            searchRange: true,
            display: true,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请选择入场时间 ',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '出场时间',
            prop: 'outTime',
            span: 24,
            search: true,
          
            searchRange: true,
            display: false,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请选择出场时间 ',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      option: {},
      intoParkOption: intoParkOption,
      outParkOption: outParkOption,
      remainParkOption: remainParkOption,
      data: [],
      img: '',
      searchForm: {},
    };
  },
  watch: {
    activeName() {
      this.showInImageBtn = this.activeName === 'intoPark';
      this.showOutImageBtn = this.activeName === 'outPark';
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        parkingSpaceGroup:this.vaildData(this.permission.parkingSpaceGroup, false),
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: false,
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initDefaultDateRange();
    this.initPayTypeList();
    this.option = this.intoParkOption;
    getParkSpaceNode().then((res) => {
      if (res.data.length > 0) {
        this.spacelist = res.data;
        this.spaceParkTemp = res.data[0];
        this.spaceId = res.data[0].id;
        this.onLoad();
      }
    });
  },
  mounted() {
    document.body.style.position = 'relative';
    console.log((document.querySelector('.avue-form__menu').style.width = 'initial'));
  },
  methods: {
    openCarGroup(row){
      this.$refs.carGroup.openDialog(row)
    },
    showImage(e, imgUrl) {
      let innerHeight = window.innerHeight;
      let innerWidth = window.innerWidth;
      let clientX = e.clientX;
      let clientY = e.clientY;
      let pageX = e.pageX;
      let pageY = e.pageY;
      this.img = document.createElement('img');
      this.img.src = imgUrl;
      this.img.style.height = '400px';
      this.img.style.width = '600px';
      this.img.style.position = 'absolute';
      this.img.style.zIndex = 10000;
      if (clientX < innerWidth / 2) {
        this.img.style.left = clientX + 'px';
      } else {
        this.img.style.left = clientX - 600 + 'px';
      }
      if (clientY < innerHeight / 2) {
        this.img.style.top = clientY + 'px';
      } else {
        this.img.style.top = clientY - 400 + 'px';
      }
      document.body.appendChild(this.img);
    },
    hideImage() {
      document.body.removeChild(this.img);
    },
    closeOutInPicDialog() {
      this.showOutInPic = false;
    },
    handleInOutImageShow(row) {
      if (this.vdui.isEmpty(row.cloudCarImage)) {
        this.$message.info('没有出场图片！');
        return;
      }
      this.dialog.outImage = row.cloudCarImage;
      this.dialog.inImage = row.cloudCarInImage;
      this.showOutInPic = true;
    },
    handleImageShow(row) {
      var carImage = row.cloudCarImage;
      if (this.vdui.isEmpty(carImage)) {
        this.$message.info('没有车辆图片！');
        return;
      }
      var images = [{ thumbUrl: row.cloudCarImage, url: row.cloudCarImage }];
      this.$ImagePreview(images, 0);
    },
    onChangePayType(item) {
      if (item) {
        this.payTypeList.forEach((e) => {
          if (e.dictKey === item) {
            this.payTypeName = e.dictValue;
          }
        });
      } else {
        this.payTypeName = '';
        this.payType = '';
      }
      this.onLoad();
    },
    initPayTypeList: function () {
      getDictionary('tempcar_pay_type').then((data) => {
        this.payTypeList = data.data;
      });
    },
    initDefaultDateRange() {
      const date = new Date();
      this.query.startTime=this.dayjs().format('YYYY-MM-DD 00:00:00')
      this.query.endTime=this.dayjs().format('YYYY-MM-DD 23:59:59')
    
     
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
     
      this.tool.clearObject(this.query);
      this.initDefaultDateRange();
      this.spaceId = this.spaceParkTemp.id;
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query.carNo = params.carNo;
      this.query.payTypeName = params.payTypeName;
      this.query.spaceId = params.spaceId;
      this.query.payType = params.payType;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page) {
      this.loading = true;
      page = page || this.page;
      this.query.payType = this.payType;
      this.query.payTypeName = this.payTypeName;
      let values = {
        ...this.query,
      };
      if (this.query.startTime!=''&&this.query.endTime!=''){ 
        values = {
          ...this.query,
          inTimeS: this.query.startTime,
          inTimeE: this.query.endTime,
          spaceId: this.spaceId,
          outTimeS:  this.query.startTime,
          outTimeE: this.query.endTime,
        };
      }
      //点击菜单后，第一次进入页面时执行此逻辑
      /*if (values.spaceId == null || values.spaceId == '') {
        if (this.spaceParkTemp != null && this.spaceParkTemp != undefined) {
          values.spaceId = this.spaceParkTemp.id;
          this.query.spaceId = this.spaceParkTemp.id;
        }
      }*/
      //若tabPanType == "intoPark" 请求入场记录查询接口
      if (this.activeName == 'intoPark') {
        getCarInList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, values)
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
      //若tabPanType == 2 请求出场记录查询接口
      if (this.activeName == 'outPark') {
        getMoneyStatistic({
          spaceId: values.spaceId,
          outTimeS: values.outTimeS,
          outTimeE: values.outTimeE,
          payType: this.payType,
          payTypeName: this.payTypeName,
          carNo: values.carNo,
        }).then(({ data }) => {
          this.shouldAccount = data.shouldAccount;
          this.realityAccount = data.realityAccount;
        });
        getCarOutList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, values)
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
      //若tabPanType == 3 请求在场记录查询接口
      if (this.activeName == 'remainPark') {
        getRemainList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, values)
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    },
    handleSwitch() {
      let oldCarNo = this.searchForm.carNo;
      //切换前清空前任列表数据
      this.query.carNo = ''
      this.query.payTypeName = ''
    
      this.query.payType = ''
      this.data = [];
      this.page.currentPage = 1;
      if (this.activeName === 'intoPark') {
        this.option = this.intoParkOption;
       
       
       
        this.onLoad();
      } else if (this.activeName === 'outPark') {
        
        this.option = this.outParkOption;
        this.onLoad();
      } else if (this.activeName === 'remainPark') {
        
        this.option = this.remainParkOption;
        this.onLoad();
      }
      // 要求切换选项时保留输入的车牌号
      this.$nextTick(()=>{
        this.searchForm.carNo = oldCarNo;
      });
    },
    //打开导入弹框
    openExportExcel() {
      this.exportExcelForm.spaceId = '';
      this.exportExcelForm.inTime = '';
      this.exportExcelForm.carNo = '';
      this.exportExcelForm.outTime = '';
      const inTimeColumn = this.findObject(this.exportExcelOption.column, 'inTime');
      const outTimeColumn = this.findObject(this.exportExcelOption.column, 'outTime');
      if (this.activeName == 'outPark') {
        inTimeColumn.display = false;
        outTimeColumn.display = true;
      } else {
        inTimeColumn.display = true;
        outTimeColumn.display = false;
      }
      this.exportExcelFlag = true;
    },
    //按条件导出
    exportExcel(form, done) {
    
      var values = { ...form };
      const { inTime, outTime } = form;
      if (inTime) {
        values = { ...form, inTimeS: inTime[0], inTimeE: inTime[1] };
        values.inTime = null;
        this.form.inTime = null;
      }
      if (outTime) {
        values = { ...form, outTimeS: outTime[0], outTimeE: outTime[1] };
        values.outTime = null;
        this.form.outTime = null;
      }
      //入场记录导出
      if (this.activeName == 'intoPark') {
        this.$refs.exportExcel.intoExportExcel(values);
        done();
      }
      //出场记录导出
      if (this.activeName == 'outPark') {
        this.$refs.exportExcel.outExportExcel(values);
        done();
      }
      //在场记录导出
      if (this.activeName == 'remainPark') {
        this.$refs.exportExcel.remainExportExcel(values);
        done();
      }
    },
  },
};
</script>

<style scoped>
.el-input.is-disabled .el-input__inner {
  color: red !important;
}
</style>
